module.exports = __webpack_public_path__ + "static/img/photo-ocean-03.1806711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-ocean-03.jpg
// module id = Xcwl
// module chunks = 1